import C from '../constants';
import {userConsts} from "../constants/users";

export const updateSubs = (subs) => {
  return {
    type: 'UPDATE_SUBS', 
    data: [...subs], 
  }
}

export const addSubscription = (sub) => {
    return {
        type: 'ADD_SUBSCRIPTION',
        data: {...sub} 
    };
}

export const removeSubscription = (sub) => {
    return {
        type: 'REMOVE_SUBSCRIPTION',
        data: {...sub},
    };
}

export const changeAvatar = (avatar) => {
    return {
        type: userConsts.CHANGE_AVATAR,
        avatar: avatar,
    }
};

export const addUserToStorage = (data = {}) => {
    return {
        type: C.ADD_USER_TO_STORAGE,
        user: {
            ...data
        },
        statusLoad: userConsts.LOADING_STATUS.LOADED,

    };
};

export const updateUserData = (user = {}) => {
    return {
        type: userConsts.UPDATE_USER_DATA,
        user: user,
        statusLoad: userConsts.LOADING_STATUS.LOADED,
    }
};

export const changePersonalData = (user = {}) => {
    return {
        type: userConsts.CHANGE_USER_PERSONAL_DATA,
        user: user,
        statusLoad: userConsts.LOADING_STATUS.LOADED,
    }
};

export const leaveTeam = (champname) => {
    return {
        type: userConsts.LEAVE_TEAM,
        champname: champname,
    }
};

export const addNewTeam = (champname, commandname) => {
    return {
        type: userConsts.ADD_TEAM,
        champ: {champname: champname, command: commandname},
    }
};

export const removeUserFromStorage = () => {
    return {
        type: C.DELETE_USER_FROM_STORAGE,
        user: {
            statusLoad: userConsts.LOADING_STATUS.NOT_LOADED
        },
    };
};


export const changeStatus = (status) => {
    return {
        type: userConsts.CHANGE_STATUS,
        status: status,
    }
};

export const changePhone = (phone) => {
    return {
        type: userConsts.CHANGE_PHONE,
        phone: phone,
    }
};


export const changeLogin = (login) => {
    return {
        type: userConsts.CHANGE_LOGIN,
        login: login,
    }
};


export const changeNickname = (nickname) => {
    return {
        type: userConsts.CHANGE_NICKNAME,
        nickname: nickname,
    }
};

export const changeEmailSub = (emailSub) => {
    return {
        type: userConsts.CHANGE_EMAILSUB,
        emailSub: emailSub,
    }
};

export const changeStatusNotify = (status) => {
    return {
        type: userConsts.CHANGE_STATUS_NOTIFY,
        status: status,
    }
};





// WEBPACK FOOTER //
// src/actions/user.jsx